module.exports = __webpack_public_path__ + "static/media/women-bean.71ad3e48.png";